export {
  LocalizedFontNames,
  LocalizedFontFamilies,
  FontSizes,
  FontWeights,
  IconFontSizes,
  createFontStyles,
} from '@fluentui/theme/lib/fonts/index';
